import $ from "jquery";

import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Header", function(app) {
  app.view.modal("NewAdvertiserCampaignModal", {
    title: "Add New Campaign",

    className: "modal-force-light",

    initialize: function() {
      app.Views.NewAdvertiserCampaignModal.__super__.initialize.apply(this, arguments);

      this.model = new app.Models.AdvertiserCampaign();
      if (app.config.network.demo) {
        this.$el.addClass("campaign-large");
      }
      this.mainPageNeedsConfirmation = window.confirmationNeeded;
    },

    body: function() {
      var form = new app.Views.NewAdvertiserCampaignForm({
        model: this.model
      });
      return form.render();
    },

    _redirect: function(location) {
      window.location.href = location;
    },

    buttons: [
      {
        text: "Cancel",
        className: "btn-secondary",
        close: true
      },
      {
        text: "Save",
        className: "btn-primary",
        click: function() {
          let self = this;
          let modalView = this.parent;
          modalView.setError("");

          if (app.config.effectiveOrganizationType.match(/network/i) && $.trim(modalView.model.get("advertiser_id")) === "") {
            modalView.setError($("<ul>").append($("<li>").text(app.nameForAdvertiser(false, false, false, true) + " is required.")));
            return;
          }

          this.$el.addClass("disabled btn-link").removeClass("btn-primary").text("Saving...");

          modalView.model.save({}, {
            wait: true,
            success: function(model, response, options) {
              var location = options.xhr.getResponseHeader("X-Redirect");
              location && modalView._redirect(location);
              if (modalView.mainPageNeedsConfirmation) {
                modalView.close();
              } else {
                // reset confirmation in case it was set by this modal
                window.confirmationNeeded = false;
              }
            },
            error: function(model, response) {
              modalView._displayServerErrors(response);
              self.$el.removeClass("disabled btn-link").addClass("btn-primary").text("Save");
            }
          });
        }
      }
    ]

  });
});
